import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as CryptoJS from 'crypto-js';
import * as i1 from '@angular/common/http';
import * as i1$1 from '@ngrx/store';
import { select } from '@ngrx/store';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { getStepDetails, getSubTaskDetails, loadSubTaskDetails, updateStepStatus } from 'visa-store';
import { MarkDirtyFormAction, MarkCleanFormAction } from 'dirty-check-store';
import * as i3 from 'ngx-toastr';
import * as i4 from 'step-status-update-payload-service';
import * as i5 from 'app-services-library';

class APIMailingAddress {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getServiceCenter(visatype, caseType, caseId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${caseId}/serviceCenters`).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
            else {
                return [];
            }
        }));
    }
    postServiceCenter(visatype, caseType, caseId, serviceCenterId, taskId, serviceCenterNameId) {
        return this.httpClient.post(`/${visatype}/${caseType}/${caseId}/serviceCenter/${serviceCenterId}/update?taskId=${taskId}&serviceCenterNameId=${serviceCenterNameId}`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getServiceCenters(isPremium, visaType, petitionType, superTaskId = null) {
        const slug = superTaskId ? `?superTaskId=${superTaskId}` : '';
        return this.httpClient.get(`/serviceCenter/${isPremium}/visaType/${visaType}/petitionType/${petitionType}${slug}`).pipe(map((response) => response.data));
    }
    getAddressFromCenter(visatype, caseType, petitionId, taskTypeId, serviceCenterNameId) {
        return this.httpClient.get(`/${visatype}/${caseType}/${petitionId}/${taskTypeId}/${serviceCenterNameId}/serviceCenters`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    postProcessingType(visatype, caseType, taskId, processingType) {
        var encryptedText = this.toEncrypt(processingType);
        return this.httpClient.post(`/${visatype}/${caseType}/${taskId}/efiling/${encryptedText}/update`, {}).pipe(map((response) => {
            if (response.status === 200) {
                return response;
            }
        }));
    }
    getProcessingType(visaType, caseType, taskId) {
        return this.httpClient.get(`/${visaType}/${caseType}/${taskId}/efiling`).pipe(map((response) => response.data));
    }
    toEncrypt(_data) {
        var pharase = 'c63a423527b24f65';
        var data = _data;
        var key = CryptoJS.enc.Latin1.parse(pharase);
        var iv = CryptoJS.enc.Latin1.parse(pharase);
        var encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.ZeroPadding
        }).toString();
        var e64 = CryptoJS.enc.Base64.parse(encrypted);
        var eHex = e64.toString(CryptoJS.enc.Hex);
        return this.encriptedData = eHex;
    }
}
APIMailingAddress.ɵfac = function APIMailingAddress_Factory(t) { return new (t || APIMailingAddress)(i0.ɵɵinject(i1.HttpClient)); };
APIMailingAddress.ɵprov = i0.ɵɵdefineInjectable({ token: APIMailingAddress, factory: APIMailingAddress.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(APIMailingAddress, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

class BaseMailingAddressLibraryService {
    constructor(store, apiService, toastr, stepStatusUpdatePayloadCostruction, appServicesLibraryService) {
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostruction = stepStatusUpdatePayloadCostruction;
        this.appServicesLibraryService = appServicesLibraryService;
        this.observableSubscription$ = new Subject();
        this.serviceCenters = [];
        this.processingType = 'regular'; // Regular or Premium
        this.visaType = 'H1-B'; // Assuming visaType is set like this, adjust if needed
        this.disabledProcessingType = false;
        this.isPremiumProcessingApplicable = false;
        this.serviceCenterSelectedName = '-';
        this.selectedServiceCenter = 0;
        this.disabledControls = false;
        this.mailingAddress = [];
    }
    loadInit() {
        var _a, _b;
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.stepId) {
            this.store.pipe(select(getStepDetails, { id: this.inputData.stepId })).pipe(takeUntil(this.observableSubscription$)).subscribe((data) => {
                this.stepDetails = data;
                this.toggleControlsStatus();
            });
            // Get Specific Task Details
            this.store
                .select(getSubTaskDetails)
                .pipe(takeUntil(this.observableSubscription$))
                .subscribe((data) => {
                var _a;
                this.subTaskDetails = data;
                if ((_a = this.subTaskDetails) === null || _a === void 0 ? void 0 : _a.id) {
                    this.taskType = this.subTaskDetails.taskTypeDetails.visaType ? this.subTaskDetails.taskTypeDetails.visaType : this.subTaskDetails.taskTypeDetails.immCategoryCode;
                    //As per the previous functionality Processing type remains disabled for mast of the VD tasks. Just adding that behaviour here as this was missed as part of the IMGLT-568.
                    // if(this.subTaskDetails?.taskTypeSaveJsonId){
                    //   this.disabledProcessingType = !((['I129EFILING'].includes(this.subTaskDetails?.subTaskTypeCode) && !this.subTaskDetails.receiptDate && (!this.subTaskDetails.receiptNumber || this.subTaskDetails.receiptNumber === '')));
                    // }else{
                    //   this.disabledProcessingType = false;
                    // }
                }
            });
        }
        if (this.inputData.filingType && this.inputData.filingType === 'e-filing') {
            this.getProcessingType();
        }
        else {
            this.getServiceCenterPremium();
            this.getMailingAddress();
        }
        this.visaType = (_b = this.inputData) === null || _b === void 0 ? void 0 : _b.visatype;
    }
    afterViewInit() {
        var _a, _b;
        (_b = (_a = this.mailingAddressForm) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.valueChanges.pipe(map(() => this.mailingAddressForm.dirty)).pipe(takeUntil(this.observableSubscription$)).subscribe(dirty => {
            if (dirty) {
                this.store.dispatch(new MarkDirtyFormAction({
                    dirty: true
                }));
            }
            else {
                this.store.dispatch(new MarkCleanFormAction({
                    dirty: false
                }));
            }
        });
    }
    onRowSelect(event) {
        this.store.dispatch(new MarkDirtyFormAction({
            dirty: true
        }));
    }
    //Toggle controls status based on step status
    toggleControlsStatus() {
        this.disabledControls = this.appServicesLibraryService.formToBeDisabled(this.stepDetails.stepStatusDetails.stepStatusCode);
        // this.disabledControls = this.stepDetails.stepStatusDetails.stepStatusCode === "NEW" || this.stepDetails.stepStatusDetails.stepStatusCode === "COMPLETE" || this.stepDetails.stepStatusDetails.stepStatusCode === "SUBMIT" ? true : false;
    }
    getMailingAddress() {
        this.apiService.getServiceCenter(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.mailingAddress = response['data'];
                this.selectedServiceCenter = this.mailingAddress.find(x => x['isSelected'] === true);
                //Load perviously selected Type and Center data
                const serviceCenters = response.data;
                serviceCenters.forEach(center => {
                    if (center.isPremiumCenter === 1) {
                        // If isPremiumCenter is 1, set processingType to 'premium'
                        this.processingType = 'premium';
                    }
                    else {
                        // Otherwise, set it to 'regular'
                        this.processingType = 'regular';
                    }
                });
            }
            this.getServiceCenter();
            //  this.onChangeProcessingType();
        });
    }
    postMailingAddress() {
        var _a, _b;
        if (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.filingType) != 'e-filing') {
            this.apiService.postServiceCenter(this.inputData.visatype, this.inputData.caseType, this.inputData.caseId, this.selectedServiceCenter['id'], this.inputData.taskId, this.serviceCenterId).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
                var _a, _b;
                this.toastr.success(response.message, 'Success');
                (_a = this.mailingAddressForm) === null || _a === void 0 ? void 0 : _a.resetForm();
                if (((_b = this.stepDetails) === null || _b === void 0 ? void 0 : _b.taskId) && this.taskType) {
                    this.store.dispatch(loadSubTaskDetails({
                        taskId: this.stepDetails.taskId,
                        visaTypeCode: this.taskType
                    }));
                }
                this.getMailingAddress();
            });
        }
        else if (((_b = this.inputData) === null || _b === void 0 ? void 0 : _b.filingType) === 'e-filing') {
            this.onProcessingTypeSave(this.processingType);
        }
    }
    updateStepStatus(status) {
        this.store.dispatch(updateStepStatus({
            payload: this.stepStatusUpdatePayloadCostruction.payloadConstruction(this.stepDetails, status),
            subTaskId: this.stepDetails.taskId,
            visaType: this.inputData.caseType === 'I130' ?
                this.inputData.caseType : this.inputData.visatype,
            stepId: this.inputData.stepId
        }));
    }
    formatAddress(...args) {
        let fulladress = args.filter(n => n).join();
        return fulladress;
    }
    onChangeProcessingType() {
        var _a;
        this.serviceCenters = [];
        this.mailingAddress = [];
        if (((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.filingType) != 'e-filing') {
            this.getServiceCenter();
        }
    }
    getServiceCenter() {
        this.apiService.getServiceCenters((this.processingType === 'regular') ? false : true, this.inputData.visatype, (this.inputData.petitionType || this.inputData.caseType), this.inputData.superTaskId)
            .subscribe((data) => {
            var _a;
            this.serviceCenters = data;
            // if(this.mailingAddress){
            //   this.serviceCenterId = this.mailingAddress[0].serviceCenterNameId;
            // }else if(this.serviceCenters && this.serviceCenters?.length === 1){
            //   this.serviceCenterId = this.selectedServiceCenter[0].id;
            // } 
            if (this.mailingAddress && this.selectedServiceCenter) {
                this.serviceCenterId = this.selectedServiceCenter['serviceCenterNameId'];
            }
            else if (this.serviceCenters && ((_a = this.serviceCenters) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                this.serviceCenterId = this.serviceCenters[0].id;
            }
            if (this.serviceCenterId && !this.selectedServiceCenter) {
                this.changeCenter({ value: this.serviceCenterId });
            }
        });
    }
    getServiceCenterPremium() {
        this.apiService.getServiceCenters(true, this.inputData.visatype, (this.inputData.petitionType || this.inputData.caseType), this.inputData.superTaskId)
            .subscribe((data) => {
            //   debugger;
            // this.serviceCenters = data;   
            this.isPremiumProcessingApplicable = data && data.length > 0 ? true : false;
            // if(this.mailingAddress){
            //   this.serviceCenterId = this.mailingAddress[0].serviceCenterNameId;
            // }     
        });
    }
    changeCenter(event) {
        this.serviceCenterId = event.value;
        this.apiService.getAddressFromCenter(this.inputData.visatype, this.inputData.caseType, this.inputData.petitionerId, this.inputData.taskTypeId, this.serviceCenterId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response && response['data']) {
                this.mailingAddress = response['data'];
                this.selectedServiceCenter = this.mailingAddress.find(x => x['isSelected'] === true);
            }
            else {
                this.mailingAddress = [];
                this.selectedServiceCenter = 0;
            }
        });
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
    onProcessingTypeSave(val) {
        this.apiService.postProcessingType(this.inputData.visatype, this.inputData.caseType, this.inputData.taskId, val).pipe(takeUntil(this.observableSubscription$)).subscribe(response => {
            this.toastr.success(response.message, 'Success');
            this.mailingAddressForm.resetForm();
            this.store.dispatch(loadSubTaskDetails({
                taskId: this.stepDetails.taskId,
                visaTypeCode: this.taskType
            }));
            this.getProcessingType();
        });
    }
    getProcessingType() {
        this.apiService.getProcessingType(this.inputData.visatype, (this.inputData.petitionType || this.inputData.caseType), this.inputData.taskId)
            .subscribe((data) => {
            this.processingType = data === null || data === void 0 ? void 0 : data.processType;
        });
    }
}
BaseMailingAddressLibraryService.ɵfac = function BaseMailingAddressLibraryService_Factory(t) { return new (t || BaseMailingAddressLibraryService)(i0.ɵɵinject(i1$1.Store), i0.ɵɵinject(APIMailingAddress), i0.ɵɵinject(i3.ToastrService), i0.ɵɵinject(i4.StepStatusUpdatePayloadService), i0.ɵɵinject(i5.AppServicesLibraryService)); };
BaseMailingAddressLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: BaseMailingAddressLibraryService, factory: BaseMailingAddressLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BaseMailingAddressLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1$1.Store }, { type: APIMailingAddress }, { type: i3.ToastrService }, { type: i4.StepStatusUpdatePayloadService }, { type: i5.AppServicesLibraryService }]; }, null); })();

/*
 * Public API Surface of base-mailing-address-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { APIMailingAddress, BaseMailingAddressLibraryService };
//# sourceMappingURL=base-mailing-address-library.js.map
